import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import Api from "../../Api/Api";

export default function ClaimEditInput(props) {
  const { id, field, value, api } = props;
  const { claimList = [] } = props;
  const [inputValue, setInputValue] = React.useState(value || "");

  return (
    <Autocomplete
      freeSolo
      options={claimList} // ✅ separate from carrier
      value={inputValue}
      inputValue={inputValue}
      onInputChange={(e, val) => {
        setInputValue(val);

        api.setEditCellValue({
          id,
          field,
          value: val,
        });
      }}
      onChange={(e, newValue) => {
        const finalValue = newValue || "";

        if (!finalValue) return;

        setInputValue(finalValue);

        api.setEditCellValue({
          id,
          field,
          value: finalValue,
        });

        Api.post("/dashboard/update-claim", {
          row_id: String(id).replace("temp-", ""),
          claim_name: finalValue,
        }).catch((err) => {
          console.log("STATUS:", err.response?.status);
          console.log("DATA:", err.response?.data);
          console.log("ERRORS:", err.response?.data?.errors);
        });
      }}
      renderInput={(params) => <TextField {...params} variant="standard" />}
      sx={{
        width: "100%",
        "& .MuiAutocomplete-inputRoot": {
          padding: "0 !important",
        },
      }}
    />
  );
}
